module.exports = __webpack_public_path__ + "files/4ae334f0828cc28bff01653a7b48cea1.svg";